import React, { useState } from "react";
import { Input, Form } from "reactstrap";
import { connect } from "react-redux";
import { setIsLoading } from "../../reduxSetup/action";
import { getSpotsByPropValueAPI } from "../../services/api";
import DropDown from "../../containers/DropDown/DropDown";
import styles from "./FormGetItemByPropValue.module.scss";
import CheckSpotsList from "../CheckSpotsList/CheckSpotsList";
import { ModalConsumer } from "../../common/ModalContext";
import cx from 'classnames'
import { getButtonText, getSelected, handleFieldChange } from "../../services/filters";
import Button from "../Button/Button";
import ModalWithDropDown from "../ModalWithDropDown/ModalWithDropDown";

const FormGetItemByPropValue = ({ setIsLoading, getItemToEdit, getActiveSpotType }) => {
    const SEARCH_SPOT_BY_OPTIONS = [
        { value: "name", label: "name" },
        { value: "url", label: "url" },
    ];

    const [searchedProp, setSearchedProp] = useState(["name"]);
    const [value, setValue] = useState("");
    const [spots, setSpots] = useState([]);

    const onSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        value &&
            searchedProp &&
            getSpotsByPropValueAPI({ prop: searchedProp[0], value }).then(
                (resp) => {
                    setSpots(resp?.data);
                    setIsLoading(false);
                }
            );
    };

    const clearSearch = () => {
        setSpots([]);
        setValue("");
    };

    return (
        <div className={styles.formContainer}>
            <h6>Check if the spot exists</h6>
            <Form onSubmit={onSubmit} className={styles.form}>
                <div className={styles.dropDownDesktop}>
                    <DropDown
                        className={styles.dropdown}
                        name="Find"
                        options={SEARCH_SPOT_BY_OPTIONS}
                        selected={searchedProp}
                        onChange={(value) => setSearchedProp([value])}
                        buttonText={getButtonText(
                            searchedProp,
                            "Select Name/URL",
                            "spotProp"
                        )}
                        onClear={() => setSearchedProp([])}
                    />
                </div>
                <div className={styles.dropDownMobile}>
                    <ModalConsumer>
                        {({ toggleModal }) => (
                            <>

                                <Button
                                    onClick={(e) => {
                                        e.preventDefault()
                                        toggleModal("spotProp");
                                    }}
                                    className={cx(
                                        styles.filterButton,
                                        searchedProp.length
                                            ? styles.labelValue
                                            : styles.labelName
                                    )}
                                >
                                    {getButtonText(
                                        searchedProp,
                                        "Select Name/URL",
                                        "spotProp"
                                    )}
                                </Button>
                            </>
                        )}
                    </ModalConsumer>
                </div>
                <Input
                    className={styles.inputEditSpot}
                    placeholder={`Write ${searchedProp[0] ? searchedProp[0] : 'Name/URL'} here`}
                    onChange={(e) => setValue(e.target.value.trim())}
                    value={value}
                />
                <Input
                    disabled={!value || !searchedProp}
                    className={styles.submit}
                    type="submit"
                    value="Find"
                />
                <ModalConsumer>
                    {({ isOpen, toggleModal, modalId }) => {
                        return (
                            (modalId === "spotProp") && (
                                <ModalWithDropDown
                                    onSave={toggleModal}
                                    toggleModal={toggleModal}
                                    isOpen={isOpen}
                                    name={modalId}
                                    options={SEARCH_SPOT_BY_OPTIONS}
                                    selected={getSelected({
                                        modalId,
                                        searchedProp
                                    })}
                                    onChange={handleFieldChange.bind({
                                        filter: modalId,
                                        changeFilter: (value) => setSearchedProp(value),
                                        selected: getSelected({
                                            modalId,
                                            searchedProp
                                        }),

                                    })}
                                    onClear={() => setSearchedProp([])}
                                />
                            )
                        );
                    }}
                </ModalConsumer>
            </Form>
            <CheckSpotsList
                spots={spots}
                getItemToEdit={getItemToEdit}
                clearSearch={clearSearch}
                getActiveSpotType={getActiveSpotType}
            />
        </div>
    );
};

const mapDispatchToProps = {
    setIsLoading,
};
export default connect(null, mapDispatchToProps)(FormGetItemByPropValue);
